import { LeagueProps } from "../types";

import {
	parlemoklliga,
	oklligabronzenord,
	oklligabronzesud,
	oklligaiberdrola,
	oklligaplatafemenina,
	oklligaplatanord,
	oklligaplatasud,
} from "../images";

export const leaguesFep: LeagueProps[] = [
	{ key: 2816, name: "OK LLIGA MASCULINA", image: parlemoklliga },
	{ key: 2817, name: "OK LLIGA FEMENINA", image: oklligaiberdrola },
	{
		key: 2819,
		name: "OK LLIGA PLATA MASCULINA NORD",
		image: oklligaplatanord,
	},
	{ key: 2820, name: "OK LLIGA PLATA MASCULINA SUD", image: oklligaplatasud },
	{ key: 2821, name: "OK LLIGA PLATA FEMENINA", image: oklligaplatafemenina },
	{
		key: 2823,
		name: "OK LLIGA BRONCE MASCULINA NORD",
		image: oklligabronzenord,
	},
	{ key: 2824, name: "OK LLIGA BRONZE MASCULINA SUD", image: oklligabronzesud },
];

export const leaguesFecapa: LeagueProps[] = [
	{ key: 3114, name: "LLIGA CATALANA" },
	{ key: 3116, name: "LLIGA CATALANA FEMENINA" },
	{ key: 3118, name: "LLIGA CATALANA PLATA" },
	{ key: 3051, name: "NACIONAL CATALANA MASCULINA" },
	{ key: 3055, name: "NACIONAL CATALANA FEMENINA" },
	{ key: 3052, name: "PRIMERA CATALANA MASCULINA" },
	{ key: 3056, name: "PRIMERA CATALANA FEMENINA" },
	{ key: 3053, name: "SEGONA CATALANA MASCULINA" },
	{ key: 3057, name: "SEGONA CATALANA FEMENINA" },
	{ key: 3054, name: "TERCERA CATALANA MASCULINA" },
	{ key: 3058, name: "JÚNIOR OR" },
	{ key: 3059, name: "JÚNIOR PLATA" },
	{ key: 3060, name: "JUVENIL OR" },
	{ key: 3061, name: "JUVENIL PLATA" },
	{ key: 3062, name: "INFANTIL OR" },
	{ key: 3063, name: "INFANTIL PLATA" },
	{ key: 3064, name: "ALEVÍ OR" },
	{ key: 3065, name: "ALEVÍ PLATA" },
	{ key: 3066, name: "FEM 19" },
	{ key: 3067, name: "FEM 17" },
	{ key: 3068, name: "FEM 15 OR" },
	{ key: 3069, name: "FEM15 PLATA" },
	{ key: 3070, name: "FEM13 OR" },
	{ key: 3071, name: "FEM13 PLATA" },
	{ key: 3072, name: "FEM 11" },
	{ key: 3073, name: "MINIFEM" },
	{ key: 3077, name: "BENJAMÍ OR BARCELONA" },
	{ key: 3078, name: "BENJAMÍ PLATA BARCELONA" },
	{ key: 3079, name: "PREBENJAMI OR BARCELONA" },
	{ key: 3080, name: "PREBENJAMI PLATA BARCELONA" },
	{ key: 3096, name: "PREBENJAMI BRONZE BARCELONA" },
	{ key: 3113, name: "PREBENJAMÍ INICIACIÓ BARCELONA" },
];
